window.DksAdvice=(()=>{
 'use strict';
 const data=window.DksAdvicePrices||{},prices=data.currency==='EUR'&&data.version===1?data.prices||{}:{};
 const valid=n=>Number.isSafeInteger(n)&&n>0;
 function lookup(sku){
  sku=String(sku||'').trim();
  if(valid(prices[sku]))return {cents:prices[sku],bundle:false};
  let parts,kind;
  if(/^DKS-\d/.test(sku)){parts=sku.slice(4).split('-');kind='number'}
  else if(/^Stang(?:Voor|Achter)?\d/.test(sku)){parts=sku.split('-');kind='named'}
  else if(/^\d+\s*\+/.test(sku)){parts=sku.split('+').map(x=>x.trim());kind='number'}
  else return null;
  if(parts.length<2||parts.length>8)return null;
  let cents=0;
  for(const part of parts){
   const match=part.match(kind==='named'?/^(?:StangVoor|StangAchter|Stang|Voet|Kit)(\d{6,7})(?:x([1-9]))?$/:/^(\d{6,7})(?:x([1-9]))?$/);
   if(!match||!valid(prices[match[1]]))return null;
   cents+=prices[match[1]]*Number(match[2]||1);
  }
  return valid(cents)?{cents,bundle:true}:null;
 }
 const money=n=>new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'}).format(n/100);
 const escape=value=>String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 function html(sku,sale,quantity=1){
  const value=lookup(sku);if(!value||!(sale>0)||!Number.isInteger(quantity)||quantity<1)return '';
  const labels=window.DksAdviceLabels||{},label=value.bundle?labels.advice_bundle||'Adviesprijs set':labels.advice||'Adviesprijs';
  const title=value.bundle?labels.advice_bundle_help||'Som van de officiële adviesprijzen van de losse onderdelen, inclusief btw.':labels.advice_help||'Officiële prijs van de fabrikant, inclusief btw.';
  return '<small class="dks-advice-price" title="'+escape(title)+'"><span>'+escape(label)+'</span><span>'+money(value.cents*quantity)+'</span></small>';
 }
 return {lookup,html};
})();
